import { breakpoints } from '../constants';
import { buildSizedImageUrl } from './imageSizeUrl';
// @snippet
/**
 * @class Picture
 */

const defaultOptions = {
  lazyload: true,
  cropType: 'center',
  fetchpriority: null,
};

class Picture {
  constructor() {}
  static render(data, options = defaultOptions) {
    options = { ...defaultOptions, ...options };
    const { sizes, size_default, alt, loadElement, url } = data;
    const { cropType } = options;
    const loading =
      options.loading ||
      data.loading ||
      (options.lazyload !== false && !loadElement ? 'lazy' : 'eager');
    const fetchpriority =
      options.fetchpriority ||
      options.fetchPriority ||
      data.fetchpriority ||
      data.fetchPriority;

    const setSourceParams = (size) => {
      const width = size.split('x')[0] || null;
      const height = size.split('x')[1] || null;
      const data = {
        width,
        height,
      };
      // Shared with the inlined collection loader, which preloads these
      // exact URLs before this renderer has been downloaded.
      const url_x1 = buildSizedImageUrl(url, size, { cropType });
      const url_x2 = buildSizedImageUrl(url, size, { cropType, retina: true });

      data['src'] = url_x1 ? url_x1.trim() : url;
      data['srcSet'] = `${url_x2.trim()} 2x, ${url_x1.trim()} 1x`;

      return data;
    };

    const renderSize = (sizeKey, sort_sizes) => {
      const params = setSourceParams(sort_sizes[sizeKey]);
      const props = {
        srcSet: params.srcSet,
        width: params.width,
        height: params.height,
        media: `(min-width: ${breakpoints[sizeKey]}px)`,
      };
      const source = document.createElement('source');
      Object.keys(props).forEach((key) => {
        source.setAttribute(key, props[key]);
      });
      return source;
    };

    const renderImg = (size_default) => {
      const params = setSourceParams(size_default);
      // `loading` and `fetchpriority` go on the element before `src`, so the
      // browser knows how to treat the image at the moment the source is set
      // rather than after a fetch has already been decided.
      const props = {};
      props['loading'] = loading;
      props['decoding'] = fetchpriority === 'high' ? 'sync' : 'async';
      if (fetchpriority) {
        props['fetchpriority'] = fetchpriority;
      }
      props['width'] = params.width;
      props['height'] = params.height;
      props['alt'] = alt;
      props['src'] = params.src;
      props['srcSet'] = params.srcSet.trim();
      const img = document.createElement('img');
      Object.keys(props).forEach((key) => {
        img.setAttribute(key, props[key]);
      });
      return img;
    };

    const wrapper = document.createElement('picture');

    if (sizes) {
      const sort_keys = Object.keys(breakpoints);
      const sort_sizes = {};
      sort_keys.reverse().forEach((size_key) => {
        if (sizes[size_key]) {
          sort_sizes[size_key] = sizes[size_key];
        }
      });

      Object.keys(sort_sizes).map((sizeKey) => {
        wrapper.appendChild(renderSize(sizeKey, sort_sizes));
      });
    }
    wrapper.appendChild(renderImg(size_default));
    return wrapper;
  }

  static imageUrl(image, size) {
    return buildSizedImageUrl(image?.src, size);
  }
}
export default Picture;
